module.exports = __webpack_public_path__ + "assets/6e1267d9d946b0236cdf6ffd02890894.png";